import React from "react";
import { Component } from "react";
import { setLoadingPage, setErrorMessage, setHeaderVisible} from "../../../reducers/actions";
import { connect } from "react-redux";
import Helmet from "react-helmet";
import moment from "moment";
import Layout from "../../../Layout/layout";
import axios from "axios";
import { apiHost } from "../../../api/apiClient";
import IButtonReportTable from "./iButtonRptTable";
import { Button } from "react-bootstrap"; 
import ReportButtonGroup from "../../commoncomponents/reportButtonGroup";
import Calendar from "react-calendar/dist/umd/Calendar";
import Select from "react-select";
import TimeZoneConvert from "../../../utils/timeZoneConvert";
import "../../../styles/reports/reports.scss";
import "../../../styles/tools/colors.scss";

class IButtonData extends Component {
    constructor(props) {
        super(props);
        this.state = {
          filter: false,
          date: new Date(),
          iButtonData:[],
          serialNo: "",
          name:"",
          IButtonDetails:[],
          customerId : "",
          customerName: "",
          calendarShow: false,
          dataPlaceholder: moment().format("MMMM YYYY"),
          calendarSelectedDate: new Date(),
          startDate: moment().clone().startOf('month').format("YYYY-MM-DD"),
          endDate : moment().clone().endOf('month').format("YYYY-MM-DD"),
          ReportDate: moment().format("YYYY-MM-DD"),
          LastRefreshDate:  null,
          loadedReportParams: null,
          selectedIButtonOption: null,
          iButtonOptionsLoading: false
        };
    this.searchText = "";
    this.customerId = "";
    this.pageSize = "50";
    this.pageKey = "1";
    this.sortDirection = "asc";
    this.sortString = "customer";
    this.setWrapperRef = this.setWrapperRef.bind(this);
      }
      

    async componentDidMount(){
      var urlAll = `${apiHost}/api/IButton/AllIbuttonSerialno`;
      this.getIbutton(urlAll);
    };

    handleWindow = () => {
      this.props.setHeaderVisibleAction(!this.props.headerHide);
    };

    handleClickOutside(event) {
        if (this.wrapperRef && !this.wrapperRef.contains(event.target)) {
        this.setState({ calendarShow: false });
      }
    }

    setWrapperRef(node) {
      this.wrapperRef = node;
    };

    componentWillUnmount() {
      document.removeEventListener("mousedown", this.handleClickOutside);
    }
      
    setIbuttonQueryObject = () => {
      let data = {};
      data.SearchString = this.searchText;
      data.customerId = this.customerId;
      data.PageSize = this.pageSize;
      data.PageNumber = this.pageKey;
      data.SortDirection = this.sortDirection;
      data.SortString = this.sortString;
      data.FetchAll = true;
      return data;
    };

    getIButtonDisplayName = (item) => (
      item.name && item.name !== item.serialNo
        ? `${item.name} (${item.serialNo})`
        : item.serialNo
    );

    createIButtonOption = (item) => ({
      value: item.id,
      label: `${item.customerName} - ${this.getIButtonDisplayName(item)} - ${item.assetName || "No asset"} - ${item.deviceName || "No device"}`,
      data: item,
    });

    getIbutton = async (url) => {
      this.setState({ iButtonOptionsLoading: true });
      try {
        let ibuttonList = await axios.get(url, {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        });

        this.setState({
          IButtonDetails: ibuttonList.data,
          iButtonOptionsLoading: false
        });
      }
      catch (e) {
        if (e.response && e.response.status == "401") {
          this.props.history.push("/login");
        } else {
          this.props.setErrorMessageAction(`${e}`);
        }
        this.setState({ iButtonOptionsLoading: false });
        console.log(`😱 Axios request failed: ${e}`);
      }
    };
    
    handleGroupDropDown = (customerName, serialNo, name, id,customerId) => {
      this.setState({
      customerName: customerName,
      serialNo: serialNo,
      name: name,
      customerId:customerId
      });
    };

    handleIButtonSelection = (selectedIButton) => {
      if (!selectedIButton) {
        this.setState({
          customerName: "",
          serialNo: "",
          name: "",
          customerId: "",
          selectedIButtonOption: null,
        });
        return;
      }

      const item = selectedIButton.data;
      this.handleGroupDropDown(
        item.customerName,
        item.serialNo,
        item.name,
        item.id,
        item.customerId
      );
      this.setState({ selectedIButtonOption: selectedIButton });
    };

    calendarFunction = () => {
      this.setState({
        calendarShow: !this.state.calendarShow,
      });
    };

    onChangeDate = (date) => {
      const momentDate = moment(date); 
      this.setState({
          calendarSelectedDate: date,
          ReportDate: momentDate.format("YYYY-MM-DD"),
          startDate: momentDate.clone().startOf('month').format("YYYY-MM-DD"),
          endDate: momentDate.clone().endOf('month').format("YYYY-MM-DD"),
          dataPlaceholder: momentDate.format("MMMM YYYY"),
          calendarShow: false,
      });
    };
    
    handleCreateReport = async () => {
      
      this.setState({
        iButtonData:[]
      });
      this.props.setLoadingPageAction(true);
      try {
        let iButtonData = await axios.post(
        `${apiHost}/api/Report/IbuttonReport`,
            {
              serialNo: this.state.serialNo,
              SearchDate:this.state.startDate,
              endDate: this.state.endDate,                       
              Timezone: localStorage.getItem("timeZoneID"),
              customerId:this.state.customerId,
              UseFiltering: false,
          },
          {
            headers: {
              Authorization: "Bearer " + localStorage.getItem("token"),
            },
          }
        );
        this.props.setLoadingPageAction(false);
        this.setState({ 
          iButtonData: iButtonData.data,
          loadedReportParams: {
            serialNo: this.state.serialNo,
            customerId: this.state.customerId,
            startDate: this.state.startDate,
            endDate: this.state.endDate,
          },
        });
        this.props.setLoadingPageAction(false);
      } 
      catch (e) {
        if (e && e.response.status == "401") {
          this.props.history.push("/login");
        } else {
          this.props.setErrorMessageAction(`${e}`);
        }
        this.props.setLoadingPageAction(false);  
        console.log(`😱 Axios request failed: ${e}`);
      }
    };
  
    render() {
      const calendarReport = this.state.calendarShow ? (
        <div
          ref={this.setWrapperRef}
          className="ParentCalender"
          style={{ position: "relative", zIndex: 100 }}
        >
          <div className="CalendarContainer" style={{ position: "absolute" }}>
            <Calendar
              defaultView="year"
              maxDetail="year"
              maxDate={new Date()}
              onChange={this.onChangeDate}
              value={this.state.calendarSelectedDate}
            />
          </div>
        </div>
      ) : (
        ""
      );

      const selectStyles = {
        control: (base, state) => ({
          ...base,
          minHeight: 44,
          backgroundColor: "#f8fafc",
          borderColor: state.isFocused ? "#244b8f" : "#dbe4ef",
          borderRadius: 8,
          boxShadow: state.isFocused ? "0 0 0 2px rgba(36, 75, 143, 0.14)" : "none",
          "&:hover": {
            borderColor: state.isFocused ? "#244b8f" : "#aebdd0",
          },
        }),
        indicatorSeparator: (base) => ({
          ...base,
          backgroundColor: "#dbe4ef",
        }),
        option: (base, state) => ({
          ...base,
          backgroundColor: state.isSelected ? "#244b8f" : state.isFocused ? "#edf3fb" : "#fff",
          color: state.isSelected ? "#fff" : "#26354f",
          fontSize: 13,
        }),
        placeholder: (base) => ({
          ...base,
          color: "#7e8da1",
        }),
        singleValue: (base) => ({
          ...base,
          color: "#17233c",
          fontWeight: 700,
        }),
        menuList: (base) => ({
          ...base,
          maxHeight: 360,
        }),
        menu: (base) => ({
          ...base,
          zIndex: 200,
          borderRadius: 8,
          overflow: "hidden",
        }),
      };
      const formatIButtonOption = (option) => {
        const item = option.data;
        const recordId = item.id ? String(item.id).slice(0, 8) : "No ID";

        return (
          <div className="ibuttonSelectOption">
            <div className="ibuttonSelectPrimary">
              <span>{item.customerName}</span>
              <strong>{this.getIButtonDisplayName(item)}</strong>
            </div>
            <div className="ibuttonSelectMeta">
              <span>Asset: {item.assetName || "No asset"}</span>
              <span>Device: {item.deviceName || "No device"}</span>
              <span>Status: {item.status || "Unknown"}</span>
              <span>State: {item.state || "Unknown"}</span>
              <span>ID: {recordId}</span>
            </div>
          </div>
        );
      };
      const iButtonOptions = this.state.IButtonDetails.map(this.createIButtonOption);
      const canCreateReport = this.state.customerName != "";
      const loadedReportParams = this.state.loadedReportParams;
      const hasPendingReportChanges = !!(
        loadedReportParams &&
        canCreateReport &&
        (
          loadedReportParams.serialNo !== this.state.serialNo ||
          loadedReportParams.customerId !== this.state.customerId ||
          loadedReportParams.startDate !== this.state.startDate ||
          loadedReportParams.endDate !== this.state.endDate
        )
      );
  
      return (
        <Layout>
          <Helmet>
            <title>iButton Monthly Report</title>
          </Helmet>
          <div className="contentBody">
            <div
              className={
                !this.props.headerHide
                  ? `contentWrapper contentWrapperSmoothRelease report-modern-page ibutton-report-page`
                  : `contentWrapper contentWrapperSmooth report-modern-page ibutton-report-page`
              }
            >
              <div className="reportHeaderTile">
                <div className="headingContainer report-modern-header">
                  <div>
                    <h2 className="mainHeading">iButton Monthly Report</h2>
                    <p>Review monthly iButton activity for a selected customer and device.</p>
                  </div>
                  <i
                    className={
                      this.props.headerHide
                        ? `fa fa-window-restore`
                        : `fa fa-window-maximize`
                    }
                    onClick={this.handleWindow}
                  />
                </div>
                <div className="inputFormGroup reportPickerGrid reportPickerToolbar">
                  <div className="inputElement reportPickerField reportPickerFieldWide">
                    <label>Customer / iButton</label>
                    <Select
                      value={this.state.selectedIButtonOption}
                      options={iButtonOptions}
                      styles={selectStyles}
                      onChange={this.handleIButtonSelection}
                      formatOptionLabel={formatIButtonOption}
                      isClearable
                      isSearchable
                      isLoading={this.state.iButtonOptionsLoading}
                      placeholder="Search customer or iButton"
                      noOptionsMessage={() => this.state.iButtonOptionsLoading ? "Loading iButtons..." : "No iButtons found"}
                    />
                  </div>
                  <div className="inputElement reportPickerField">
                    <label>Month</label>
                    <ReportButtonGroup
                      function={this.calendarFunction}
                      dropDown={calendarReport}
                      placeholder={this.state.dataPlaceholder}
                      icon="fa-calendar"
                    />
                  </div>
                  <div className="inputElement reportPickerActions">
                    {canCreateReport ? (
                      <Button
                        className={hasPendingReportChanges ? "reportPickerCreateButton report-create-pending" : "reportPickerCreateButton"}
                        variant="primary"
                        onClick={this.handleCreateReport}
                        size="sm"
                      >
                        <i className="fa fa-address-card-o"></i>
                        Create Report
                      </Button>
                    ) : (
                      <Button
                        className="reportPickerCreateButton"
                        variant="primary"
                        onClick={this.handleCreateReport}
                        size="sm"
                        disabled
                      >
                        <i className="fa fa-address-card-o"></i>
                        Create Report
                      </Button>
                    )}
                  </div>
                </div>
              </div>
              <TimeZoneConvert />
              <div className="reportBody">
                <IButtonReportTable iButtonData={this.state.iButtonData}
                assetCustomerName={this.state.customerName}
                />
              </div>
            </div>
          </div>
        </Layout>
      );
    }
  }     
const mapStateToProps = (state) => ({
    headerHide: state.headerHide,
  });
const mapDispatchToProps = {
  setLoadingPageAction: setLoadingPage,
  setErrorMessageAction: setErrorMessage,
  setHeaderVisibleAction: setHeaderVisible
};
  
export default connect(mapStateToProps, mapDispatchToProps)(IButtonData);
  
